import { Flex, Text } from '@skin-seoul/design-system';

export const ReviewEmpty = () => {
  return (
    <Flex direction="column" align="flex-start" w="full" gap="8px">
      <Text color="neutral.700" textStyle="paragraph.small" fontWeight="semibold">
        Be the first to write a review!
      </Text>
      <Text color="neutral.700" textStyle="paragraph.small" fontWeight="normal">
        Tell others what you think!
      </Text>
    </Flex>
  );
};

export default ReviewEmpty;
